import React, { Component } from 'react';
import { connect } from 'react-redux';
import { latLng2Tile } from 'google-map-react/utils';
import utils  from 'google-map-react/utils';
import cx from 'classnames';
import Actions from './actions.js';

const TileSize = 256;

function latLng2World({ lat, lng }) {
      const sin = Math.sin(lat * Math.PI / 180);
      const x = lng / 360 + 0.5;
      let y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;

      y = y < 0 // eslint-disable-line
        ? 0
        : y > 1 ? 1 : y;
      return { x, y };
}

function latLng2Px({ lat, lng }, zoom) {
    let coord = latLng2World({lat, lng})
    coord.x = coord.x * Math.pow(2, zoom) * TileSize;
    coord.y = coord.y * Math.pow(2, zoom) * TileSize;
    return coord;
}

function relativePx(center, latlng, zoom)
{
    const centerPx = latLng2Px(latlng, zoom);
    const px = latLng2Px(center, zoom);
    return {
        x: px.x - centerPx.x,
        y: px.y - centerPx.y,
    }
}

function getQuadrant(latlng, center, zoom) {
    const relative = relativePx(latlng, center, zoom);
    if (relative.x < 200 && relative.x > -200 && relative.y < 0) {
        return 'N';
    }
    if (relative.x < 200 && relative.x > -200 && relative.y >= 0) {
        return 'S';
    }
    if (relative.x < 0 && relative.y < 0) {
        return 'NW';
    }
    if (relative.x < 0 && relative.y >= 0) {
        return 'SW';
    }
    if (relative.x >= 0 && relative.y < 0) {
        return 'NE';
    }
    if (relative.x >= 0 && relative.y >= 0) {
        return 'SE';
    }
}

const openVilla = (url) => {
    var win = window.open(url, '_blank');
    win.focus();
}

    
class MapMarker extends Component {
    constructor(props) {
        super(props);
        this.state = {showHint: false, showing: false};
        this.showDetails = this.showDetails.bind(this);
        this.handleMapHover = this.handleMapHover.bind(this);
        this.handleMapUnHover = this.handleMapUnHover.bind(this);
        this._node = null;
        this.id = props.id;
    }

    handleMapHover(e) {
        if (e.detail.id == this.id) {
            this.setState({showing: true });
        }
    }

    handleMapUnHover(e) {
        if (e.detail.id == this.id) {
            this.setState({showing: false});
        }
    }
    componentWillUnmount() {
        this._node.removeEventListener('maphover', this.handleMapHover, true);
        this._node.removeEventListener('mapunhover', this.handleMapUnHover, true);
    }

    componentDidMount() {
       this._node.addEventListener('maphover', this.handleMapHover,true);
       this._node.addEventListener('mapunhover', this.handleMapUnHover,true);
    }

    
    showDetails() {
        this.props.onClickMarker(this.props, this);
    }
    
    getQuadrant() {
        const latlng = { lat: this.props.lat, lng: this.props.lng };
        return getQuadrant(latlng, this.props.center, this.props.zoom)
    }

    render() {
        // const quadrant = this.getQuadrant();
        const { isShowing } = this.props;
        return (
            <div ref={(ref) => this._node = ref} className={cx('map-marker', (isShowing || this.state.showing) ? 'active' : '' )} onClick={this.showDetails}></div>
        )
    }
}

export default connect((state) => {
    return {
        zoom: state.zoom,
        center: state.center,
    }
})(MapMarker)
